import XmBaseRequest from "./base"

export default class XmApis extends XmBaseRequest {
  constructor(config) {
    super(config)
  }
  async getSignature() {
    return this.get({
      url: "/v1/blade-auth/oauth/signature"
    }).then(res => {
      return this.normalRespnseHandler(res)
    })
  }
  async getToken(params = {}) {
    return this.post({
      url: "/v1/blade-auth/oauth/token",
      params
    })
      .then(res => {
        return this.normalRespnseHandler(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  async getMenus() {
    return this.get({
      url: "/v1/vocust-desk/menu/routes"
    })
      .then(res => {
        return this.normalRespnseHandler(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
  async getTenantDetail() {
    return this.get({
      url: "/v1/vocust-desk/tenant/detail"
    })
      .then(res => {
        return this.normalRespnseHandler(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}
